import { memo, useMemo } from 'react';

import { Box } from '@zillow/constellation-10';

import { LoadingHeading, LoadingParagraph } from '@zg-rentals/loading-components';
import { formatAddress } from '@zg-rentals/zillow-rental-manager/utils';

type Address = {
  street: string;
  city: string;
  state: string;
  unit: string;
  name?: string;
  zip: string;
};

type Props = {
  address?: Address;
};

const AddressDetails = ({ address }: Props): JSX.Element => {
  const { formattedStreet, formattedCityStateZip } = useMemo(() => {
    if (!address) {
      return { formattedStreet: '', formattedCityStateZip: '' };
    }
    return formatAddress(address);
  }, [address]);

  return (
    <Box css={{ overflow: 'hidden', marginRight: { md: '200', lg: '400' } }} data-testid="AddressDetails">
      <Box css={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
        <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <LoadingHeading
            level={5}
            isLoading={Boolean(!formattedStreet)}
            loadingWidth="400px"
            css={{
              textStyle: { base: 'body-bold', lg: 'heading-sm' },
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              maxWidth: { base: '62vw', mobile390: '50vw', xl: '60vw', xxl: '800px' },
            }}
          >
            {formattedStreet}
          </LoadingHeading>
          <LoadingParagraph
            textStyle="body-sm"
            isLoading={Boolean(!formattedCityStateZip)}
            loadingWidth="400px"
            css={{ color: 'text.subtle', fontSize: { lg: 'body' } }}
          >
            {formattedCityStateZip}
          </LoadingParagraph>
        </Box>
      </Box>
    </Box>
  );
};

export default memo(AddressDetails);
